import React from 'react';
import PropTypes from 'prop-types';
import Provider from 'react-redux/es/components/Provider';
import ReactOnRails from 'react-on-rails';
import ListViewLeftPart from '../../containers/Country/ListViewLeftPart';
import ListViewRightPart from '../../containers/ListViewRightPart/ListViewRightPart';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainSearch from '../../containers/MainSearch/MainSearch';
import BreadCrumbs from '../../containers/BreadCrumbs/BreadCrumbs';
import './CountryContainer.scss';

const CountryComponent = (props) => {
  const appStore = ReactOnRails.getStore('appStore');

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={props.footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <BreadCrumbs />
                </div>
              </div>
              <div className="row stretch">
                <div className="col-md-9">
                  <ListViewLeftPart title={props.title} descTeaser={props.descTeaser} mapUrlLv={props.mapUrlLv} />
                </div>

                <div className="col-md-3">
                  <div className="rightContainer">
                    <ListViewRightPart />
                  </div>
                </div>
              </div>
              <MainSearch />
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

CountryComponent.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

CountryComponent.defaultProps = {
  footerData: {},
};

export default CountryComponent;
